export const testIDs = {
  CONFIRMATION_ICON: 'confirmation-icon',
  MEDICAL_ALERT_ICON: 'medical-alert-icon',
  QUESTION_MARK_ICON: 'question-mark-icon',
}
